import * as React from "react";
import { makeStyles } from "@mui/styles";
import { Typography } from "@mui/material";
import { body1, body2 } from "../../../styles/typography";
import Grid from "@mui/material/Grid2";
import tokens from "../../../styles/designTokens";
import { GuideData, getGuideDataByCountry } from "../../../utils/guideDataLoader";

interface GuideTabProps {
  countryCode?: string;
}

const useStyles = makeStyles(() => ({
  info: {
    ...body1,
    whiteSpace: 'pre-line',
    color: tokens.core1
  },
  propertyName: {
    ...body2,
    color: tokens.core3
  },
  topMatter: {
    paddingBottom: '1.5rem',
    borderBottom: '1px solid #ddd'
  },
  resultsPageBody: {
    flexGrow: 0.5,
    padding: '20px 20px 0 20px',
    backgroundColor: tokens.white
  },
}));

const GuideTab: React.FC<GuideTabProps> = ({ countryCode }) => {
  const classes = useStyles();

  const guideData = React.useMemo<GuideData>(() => {
    const countryData = getGuideDataByCountry(countryCode);
    return countryData || getGuideDataByCountry('DEFAULT');
  }, [countryCode]);

  return (
    <div>
      <div className={classes.topMatter}>
        <Grid size={12} className={classes.resultsPageBody}>
          <Typography className={classes.propertyName}>{guideData.country}</Typography>
          <Typography className={classes.info}>{guideData.title}</Typography>
        </Grid>
      </div>

      {guideData.properties.map((property, index) => (
        <Grid key={index} size={12} className={classes.resultsPageBody}>
          <Typography className={classes.propertyName}>{property.name}</Typography>
          <Typography className={classes.info}>{property.value || 'N/A'}</Typography>
        </Grid>
      ))}
    </div>
  );
};

export default GuideTab;